<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5xmhVl/media/FC-9781528980913.jpg?1692133193100" alt="This image is the cover for the book The Serpent Warrior"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Serpent Warrior
      </h1>
      <p class="bookDescription body article font2">
        <p>A mystical tale of a half Scythian, half Mongolian warrior called ‘Manu Kai’, who was born to a Scythian tribal Chieftain. Set in Scythia around 2400 B.C., the raw brutality of the age, and his bitter and justifiable hatred of the rising Roman Empire, creates conflict between his role within the Agari priesthood and his duty as a warrior and future leader of his people. He is destined to face many trials and tribulations along the way, but perhaps the greatest trial of all will be facing his own inner demons which threaten to engulf him at every turn, and will eventually drive him to the very edge of reason.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        P. Edwards
      </h2>
      
      <p class="authorDescription body article">P. Edwards was born in Pontypool in South Wales, and now lives in Newport with her family and two rescue cats. She has a wide range of interests that include listening to music, travel, reading and ancient history, and she loves nothing more than to be traipsing through an ancient forest, or surrounded by some old ancient ruins somewhere. When she’s not doing any of this, she simply likes to spend some quality time with old friends or close family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?36754f57